<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" :title="`Default progress bar, ${bars.prog1}%`" />
    <vc-progress name="prog-1" :fill="bars.prog1" color="red" @progress="onProgress($event)" />
    <progress-tester bar="prog1" />

    <example-title src="example-2.html" :title="`Custom color, ${bars.prog2}%`" />
    <vc-progress name="prog-2" track-color="black" progress-color="red" @progress="onProgress($event)" :fill="bars.prog2" />
    <progress-tester bar="prog2" color="red" />

    <example-title src="example-3.html" :title="`Custom color and height, ${bars.prog3}%`" />
    <vc-progress name="prog-3" track-color="deep-purple" progress-color="orange" @progress="onProgress($event)" :fill="bars.prog3" :height="16" />
    <progress-tester bar="prog3" color="orange" />

    <example-title src="example-4.html" :title="`Custom color, height and width, ${bars.prog4}%`" />
    <vc-progress name="prog-4" track-color="light-green" progress-color="green" @progress="onProgress($event)" :fill="bars.prog4" :height="32" width="70%" />
    <progress-tester bar="prog4" color="green" />

    <example-title src="example-5.html" title="Indeterminate" />
    <vc-progress name="prog-5" track-color="black" progress-color="pink" indeterminate :height="24" />

    <example-title src="example-6.html" :title="`Disabled, ${bars.prog5}%`" />
    <vc-progress name="prog-6" track-color="light-green" progress-color="red" disabled :fill="bars.prog5" />

    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ProgressPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      bars: {
        prog1: 0,
        prog2: 10,
        prog3: 30,
        prog4: 40,
        prog5: 80
      }
    }
  },
  created () {
    this.$on('progress:update', (data) => {
      const bar = this.bars[data.bar]
      const value = data.value
      let newValue = 0
      switch (value) {
        case 100:
          newValue = 100
          break
        case 0:
          newValue = 0
          break
        case 10:
        case -10:
          newValue = bar + value
          break
      }
      this.bars[data.bar] = newValue
    })
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onProgress ($event) {
      console.log($event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/progress.vue